module.exports = __webpack_public_path__ + "images/stickers/pete-love.e226d3edc2bc1c9439bc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-love.png
// module id = OiHo
// module chunks = 12